module.exports = __webpack_public_path__ + "img/img_jf.74fb6aed.png";